module.exports = __webpack_public_path__ + "media/bootstrap-icons/pentagon-e7d0c7e1.svg";